import { SvgIcon, SxProps } from "@mui/material";
import Grid2Svg from "jsx:../../../Images/Icons/FontAwesome/solid/grid-2.svg";

export function Grid2Icon(props: SxProps) {
    return <SvgIcon component={Grid2Svg} inheritViewBox sx={props} />;
}
